import {DateTimeFilter, ProviderFilter, StatusFilter, TypeFilter} from "components/dataTable/columnFilter.jsx";
import {DataTable} from "components/dataTable/index.jsx";
import {useAppDataStore} from "@/mobx/appDataStore.jsx";
import formatters from "helpers/formatters.jsx";
import {useEffect, useMemo} from "react";
import moment from "moment";

export default function Providers(props) {
  const appDataStore = useAppDataStore()

  const columns = useMemo(() => ([
    {
      accessorKey: 'number',
      header: 'Número',
    },
    {
      accessorKey: 'amount',
      header: 'Valor',
      cell: ({cell}) => formatters.cash(cell.getValue()),
    },
    {
      accessorKey: 'type',
      header: 'Tipo',
      opFilter: 'eq',
      cell: ({cell}) => formatters.transactionType(cell.getValue()),
      customFilter: (column, table) => <TypeFilter column={column} table={table}/>
    },
    {
      accessorKey: 'status',
      header: 'Estado',
      opFilter: 'eq',
      cell: ({cell}) => formatters.status(cell.getValue()),
      customFilter: (column, table) => <StatusFilter column={column} table={table}/>
    },
    {
      accessorKey: 'providerError',
      header: 'Error',
      enableColumnFilter: false,
    },
    {
      accessorKey: 'transactionId',
      header: 'ID Proveedor',
    },
    {
      accessorKey: 'providerName',
      header: 'cuenta TG',
      opFilter: 'eq',
      customFilter: (column, table) => <ProviderFilter column={column} table={table}
                                                       options={appDataStore.user.Providers}/>
    },
    {
      accessorKey: 'createdAt',
      header: 'Fecha/Hora',
      customFilter: (column, table) => <DateTimeFilter column={column} table={table}/>,
      cell: ({cell}) => moment(cell.getValue()).format('DD/MM/YYYY HH:mm:ss'),
      exportFormat: (row) => moment(row.createdAt).format('DD/MM/YYYY HH:mm:ss')
    },
  ]), [])

  const dataFetch = async (
    records,
    currentPage,
    order,
    search,
    filter,
    attributes
  ) => {
    return appDataStore.post(`/app/datasource/Transaction`, {
        records,
        currentPage,
        order,
        search,
        filter,
        attributes,
        or: appDataStore.user.Providers.map(provider => ({
          key: 'providerName',
          value: provider.user,
          operator: 'eq'
        })),
        searchAttributes: ['number', 'transactionId', 'providerName']
      }
    );
  }


  useEffect(() => {
  }, []);

  return (
    <>
      <DataTable exportFileName={`historial_recargas_${moment().format('DDMMYY_HHmm')}`}
                 columns={columns}
                 dataFetch={dataFetch}
                 defaultSorting={[{id: 'id', desc: true}]}/>
    </>
  )
}